// React imports.
import React from "react";

import { Assessment3VendorAssignedStatusEnum } from "../state";
import { Assessment3StepsEnum } from "../state";
import { Assessment3HHDataReceivedStatusEnum } from "../state";
import { Assessment3HHVendorsSelectedStatusEnum } from "../state";
import { Assessment3HHServedByVendorsProvidingDataStatusEnum } from "../state";
import { Assessment3RateOfReturnStatusEnum } from "../state";

const Assessment3BottomText = ({state, fuelType }) => (
    <div>
        {(state.CurrentAssessementStepIndex == Assessment3StepsEnum.VendorAssignmentResultsElectric
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.VendorAssignmentResultsNaturalGas
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.VendorAssignmentResultsFuelOil
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.VendorAssignmentResultsPropane)
          &&
          <React.Fragment>
              {fuelType.numHouseholds === 0
                &&<span>Please click “Next” to continue.</span>
              }
              { (fuelType.vendorAssignmentStatus == Assessment3VendorAssignedStatusEnum.Over95NoIssues
                &&fuelType.viewAnyway != true)
                &&<span>
                    <p>
                        This means that you likely do not have a data reliability issue with regard to your client application for&nbsp;{fuelType.descriptionHeat}&nbsp; households. 
                    </p>
                    <p>
                        No further action is required for&nbsp;{fuelType.descriptionHeat}&nbsp; households in Assessment #3.
                        If you want to analyze potential data reliability issues for&nbsp;{fuelType.descriptionHeating}&nbsp; data anyway, click&nbsp;
                        <button className="dataButton"
                              onClick={(changeEvent) => state.assessment3ViewAnywayVendorAssigned(changeEvent, fuelType)}>
                              here
                          </button>
                        .&nbsp; Otherwise, click next.
                    </p>
                  </span>
              }
             &nbsp;{(fuelType.vendorAssignmentStatus == Assessment3VendorAssignedStatusEnum.Under95NotMeetTarget)
                &&<span>
                    <p>
                        The fact that less than 95% of your assisted&nbsp;{fuelType.descriptionHeat}&nbsp; households are assigned to a main
                        heating vendor indicates that you may not be processing LIHEAP applications correctly and/or
                        you may not be correctly accounting for the number of households being assisted by each vendor.
                        Additionally, having a high percentage of your households assigned to a vendor is important for
                        other things, such as ensuring that vendors are paid properly for the assisted households they serve. 
                    </p>
                    <p>
                        In order to address this issue, you will most likely need to revise your LIHEAP client application
                        or and/or client waiver. Answer the follow-up questions below to investigate further. 
                    </p>
                  </span>
              }
          </React.Fragment>
        }
        {(state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectric
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGas
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOil
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropane)
          &&
          <React.Fragment>
              {fuelType.numHouseholds === 0
                &&<span>Please click “Next” to continue.</span>
              }

              { ((fuelType.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.OverTargetNoIssues)
                &&(fuelType.viewAnywayDataReceived != true))
                &&<span>
                    <p>
                        This means that your data is likely representative of all LIHEAP households in your
                        state/territory and you likely do not have a data reliability issue with regards to data
                        recording and processing for&nbsp;{fuelType.descriptionHeating}&nbsp; expenditure data.
                    </p>
                    <p>
                        No further action is required for&nbsp;{fuelType.descriptionHeat}&nbsp; households in Assessment #3. If you
                        want to analyze potential data reliability issues for&nbsp;{fuelType.descriptionHeating}&nbsp; data anyway, click
                        &nbsp;<button className="dataButton"
                            onClick={(changeEvent) => state.assessment3ViewAnywayDataReceived(changeEvent, fuelType)}>
                            here
                        </button>.&nbsp;
                        Otherwise, click next.
                    </p>
                </span>
                }
                {(fuelType.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.NotMeetTarget)
                &&<span>
                    <p>
                        Please continue to the following supplemental investigations in order to determine the cause(s)
                        of this data reliability issue and actions you can take to address it.

                    </p>
                </span>
              }
          </React.Fragment>
        }



        {(state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup1Result
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup1Result
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup1Result
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup1Result)
          &&
          <React.Fragment>
              { (fuelType.householdsServedByVendorsSelectedStatus == Assessment3HHVendorsSelectedStatusEnum.NotMeetTarget)
                &&<span>
                    <p>
                        Based on the information you provided, the&nbsp;{fuelType.description}&nbsp;vendors from whom you requested data DO NOT
                        represent at least&nbsp;{fuelType.targetPercentHouseholdsCoveredString}&nbsp;of the&nbsp;{fuelType.descriptionHeat}&nbsp; households that received LIHEAP assistance in your
                        state/territory. 
                    </p>
                    <p>
                        It is not possible to collect main heat billing data from at least&nbsp;{fuelType.targetPercentHouseholdsCoveredString}&nbsp;of your&nbsp;{fuelType.descriptionHeat}&nbsp;
                        households if you DO NOT request data from vendors that represent at least&nbsp;{fuelType.targetPercentHouseholdsCoveredString}&nbsp;of those households.
                        Therefore, your first step to addressing this data reliability issue for&nbsp;{fuelType.descriptionHeat}&nbsp; households
                        is to either request data from&nbsp;{fuelType.description}&nbsp;vendors that represent a greater percentage of your
                        LIHEAP clients OR request data from a larger number of&nbsp;{fuelType.description}&nbsp;vendors. 
                    </p>
                    <p>
                        Please describe your plans to address this issue in the box below. 
                    </p>
                    <p>
                        <textarea  name="householdsServedByVendorsSelectedStatusDesc"
                            id="householdsServedByVendorsSelectedStatusDesc" style={{width:"100%"}}
                            value={fuelType.householdsServedByVendorsSelectedStatusDesc}
                            onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}></textarea>

                    </p>
                </span>
                }
                {(fuelType.householdsServedByVendorsSelectedStatus == Assessment3HHVendorsSelectedStatusEnum.OverTargetNoIssues)
                &&<span>
                <p>
                    Based on the information you provided, the&nbsp;{fuelType.description}&nbsp;vendors from whom you requested data
                    DO represent at least&nbsp;{fuelType.targetPercentHouseholdsCoveredString}&nbsp;of the&nbsp;{fuelType.descriptionHeat}&nbsp; households that received LIHEAP assistance
                    in your state/territory. Therefore, the cause of your data reliability issue must lie somewhere
                    else. 
                </p>
                <p>
                    Please continue with the next supplemental assessment to investigate further.
                </p>
                </span>
              }
          </React.Fragment>
        }

        {(state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup2Result
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup2Result
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup2Result
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup2Result)
          &&
          <React.Fragment>
              { (fuelType.householdsServedByVendorsProvidingDataStatus == Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget)
                &&<span>
                    <p>
                        Based on the information you provided, the&nbsp;{fuelType.description}&nbsp;vendors that actually submitted
                        main heating expenditure data DO NOT represent at least&nbsp;{fuelType.targetPercentHouseholdsCoveredString}&nbsp;of the&nbsp;{fuelType.descriptionHeat}&nbsp; households
                        that received LIHEAP assistance in your state/territory. 
                    </p>
                    <p>
                        It is important that you receiving billing data for at least&nbsp;{fuelType.targetPercentHouseholdsCoveredString}&nbsp;of your&nbsp;{fuelType.descriptionHeat}&nbsp;
                         households to ensure that your sample is represented of the entire
                        population of&nbsp;{fuelType.descriptionHeat}&nbsp; households in the state/territory. In order to address
                        this issue you can either
                    </p>
                    <ol>
                        <li>
                            request data from a larger number of&nbsp;{fuelType.description}&nbsp;vendors or
                        </li>
                        <li>
                            find a way to compel the vendors from whom you originally requested data to comply with those data requests.
                        </li>
                    </ol>
                    <p>
                        Please describe your plans to address this issue in the box below. 
                    </p>
                    <p>
                        <textarea  name="householdsServedByVendorsProvidingDataStatusDesc"
                            id="householdsServedByVendorsProvidingDataStatusDesc" style={{width:"100%"}}
                            value={fuelType.householdsServedByVendorsProvidingDataStatusDesc}
                            onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}></textarea>

                    </p>
                </span>
                }
                {(fuelType.householdsServedByVendorsProvidingDataStatus == Assessment3HHServedByVendorsProvidingDataStatusEnum.OverTargetNoIssues)
                &&<span>
                    <p>
                        Based on the information you provided, the&nbsp;{fuelType.description}&nbsp;vendors that actually submitted
                        data DO represent at least&nbsp;{fuelType.targetPercentHouseholdsCoveredString}&nbsp;of the&nbsp;{fuelType.descriptionHeat}&nbsp; households that received
                        LIHEAP assistance in your state/territory. Therefore, the cause of your data
                        reliability issue must lie somewhere else. 
                    </p>
                    <p>
                        Please continue with the next supplemental assessment to investigate further.
                    </p>
                </span>
              }
          </React.Fragment>
        }

        {(state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedElectricSup3Result
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedNaturalGasSup3Result
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedFuelOilSup3Result
          ||state.CurrentAssessementStepIndex == Assessment3StepsEnum.NumHouseholdsDataCollectedPropaneSup3Result)
          &&
          <React.Fragment>
              { (fuelType.rateOfReturnStatus == Assessment3RateOfReturnStatusEnum.Under75NotMeetTarget)
                &&<span>
                    <p>
                        Based on the information you provided, the&nbsp;{fuelType.description}&nbsp;vendors that actually
                        submitted main heating expenditure data DO NOT represent at least&nbsp;{fuelType.targetPercentHouseholdsCoveredString}&nbsp;of the
                       &nbsp;{fuelType.descriptionHeat}&nbsp; households that received LIHEAP assistance in your state/territory. 
                    </p>
                    <p>
                        It is important that you receiving billing data for at least&nbsp;{fuelType.targetPercentHouseholdsCoveredString}&nbsp;of your
                       &nbsp;{fuelType.descriptionHeat}&nbsp; households to ensure that your sample is represented of the entire
                        population of&nbsp;{fuelType.descriptionHeat}&nbsp; households in the state/territory. In order to address
                        this issue you can either
                    </p>
                    <ol>
                        <li>
                            request data from a larger number of&nbsp;{fuelType.description}&nbsp;vendors or
                        </li>
                        <li>
                            find a way to compel the vendors from whom you originally requested data to comply with those data requests.
                        </li>
                    </ol>

                    <p>
                        Please describe your plans to address this issue in the box below. 
                    </p>
                    <p>
                        <textarea  name="rateOfReturnStatusDesc"
                            id="rateOfReturnStatusDesc" style={{width:"100%"}}
                            value={fuelType.rateOfReturnStatusDesc}
                            onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </p>
                </span>
                }
                {(fuelType.rateOfReturnStatus == Assessment3RateOfReturnStatusEnum.Over75NoIssues)
                &&<span>
                    <p>
                        Based on the information you provided, your&nbsp;{fuelType.description}&nbsp;vendors are returning data
                        for enough households to ensure that your sample is representative of your entire
                        population of assisted households that use&nbsp;{fuelType.descriptionHeat}. Please review the
                        information you have entered at each stage of Assessment #3 with your
                        IT staff to ensure that it is correct. 
                    </p>
                    <p>
                        In the meantime, there are couple of other factors that could be contributing
                        to a potential data reliability issue. Please answer the following
                        questions to investigate further:
                    </p>
                    <ol>
                        <li>
                            Are there&nbsp;{fuelType.description}&nbsp;vendors that did not submit all data elements?
                            <br/>
                            <label>
                                <input type="radio"
                                    name="vendorsNotIncludeAllDataElementsFlag"
                                    id="vendorsNotIncludeAllDataElementsFlag_true"
                                    value="true"
                                    checked={fuelType.vendorsNotIncludeAllDataElementsFlag === true}
                                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                                />
                                <span>Yes</span>
                            </label>
                            &nbsp;&nbsp;
                            <label>
                                <input type="radio"
                                    name="vendorsNotIncludeAllDataElementsFlag"
                                    id="vendorsNotIncludeAllDataElementsFlag_false"
                                    value="false"
                                    checked={fuelType.vendorsNotIncludeAllDataElementsFlag === false}
                                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                                />
                                <span>No</span>
                            </label>
                            <br/ >
                            {fuelType.vendorsNotIncludeAllDataElementsFlag === false
                              && <span><strong>No action needed</strong></span>}
                            {fuelType.vendorsNotIncludeAllDataElementsFlag === true
                              && <span>
                                    <strong>Requires followup.</strong>&nbsp;
                                    Vendors need to submit all of the required data elements for their data to be useable.
                                    Grant Recipients should ensure that all of their vendors are sending all of the
                                    necessary data elements for every LIHEAP client. Please describe your plans
                                    to address this issue in the box below.
                                    <br/>
                                    <textarea  name="vendorsNotIncludeAllDataElementsDesc"
                                          id="vendorsNotIncludeAllDataElementsDesc" style={{width:"100%"}}
                                          value={fuelType.vendorsNotIncludeAllDataElementsDesc}
                                          onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}></textarea>
                                    <br/>
                                </span>}
                            <br/>  
                        </li>
                        <li>
                            Was IT staff able to match accounts from&nbsp;{fuelType.description}&nbsp;vendors? 
                            <br/>
                            <label>
                                <input type="radio"
                                    name="ableToMatchAccountsFlag"
                                    id="ableToMatchAccountsFlag_true"
                                    value="true"
                                    checked={fuelType.ableToMatchAccountsFlag === true}
                                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                                />
                                <span>Yes</span>
                            </label>
                            &nbsp;&nbsp;
                            <label>
                                <input type="radio"
                                    name="ableToMatchAccountsFlag"
                                    id="ableToMatchAccountsFlag_false"
                                    value="false"
                                    checked={fuelType.ableToMatchAccountsFlag === false}
                                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}
                                />
                                <span>No</span>
                            </label>
                            <br/ >
                            {fuelType.ableToMatchAccountsFlag === true
                              && <span><strong>No action needed</strong></span>}
                            {fuelType.ableToMatchAccountsFlag === false
                              && <span>
                                    <strong>Requires followup.</strong>&nbsp;
                                    IT staff need to be able to match main
                                    heating vendor accounts with&nbsp;{fuelType.description}&nbsp;baseload or other accounts in order
                                    for the data to be useable. All grant recipients should ensure that their IT staff
                                    have the resources they need to match accounts to LIHEAP clients from multiple
                                    vendors and sources. Please describe your plans to address this issue
                                    in the box below.
                                    <br/>
                                    <textarea  name="ableToMatchAccountsDesc"
                                          id="ableToMatchAccountsDesc" style={{width:"100%"}}
                                          value={fuelType.ableToMatchAccountsDesc}
                                          onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}></textarea>
                                    <br/>
                                </span>}
                            <br/>  
                        </li>
                    </ol>
                </span>
              }
          </React.Fragment>
        }


    </div>
);

export default Assessment3BottomText;
